import React, { useEffect, useRef, useState } from "react";
import styles from "./Navbar.module.css";
import NavigationMenu from "./navigation-menu/NavigationMenu";
import { useNavigate } from "react-router-dom";
import { API_BASE_URL } from "configs/AppConfig";

// const navItems = [
//   { text: "Home", className: styles.navItem },
//   {
//     text: "Products & Services",
//     className: styles.navItemWide,
//     isDropDown: true,
//     subMenu: [
//       { name: "Bodyshop Business Improvement Program" },
//       { name: "Bodyshop Health Checks" },
//       { name: "Auto-retail After-sales Process Audits" },
//       { name: "Dealership Facility Design , Planning & Execution" },
//       { name: "Auto Retail Management Software" },
//       { name: "Skill Enhancement Programs" },
//     ],
//   },
//   { text: "Reviews & Blogs", className: styles.navItem },
//   { text: "Business Enquiry", className: styles.navItem },
//   { text: "Case Studies", className: styles.navItem },
//   { text: "About", className: styles.navItemNarrow },
// ];

function Navbar() {
  const [isVisible, setIsVisible] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const [selectedItem, setSelectedItem] = useState("");
  const [informations, setInformations] = useState([]);
  const [navItems, setNavItems] = useState([
    { text: "Home", className: styles.navItem, path: "/" },
    {
      text: "Products & Services",
      className: styles.navItemWide,
      isDropDown: false,
      path: undefined,
      subMenu: [
        {
          name: "Bodyshop Business Improvement Program",
          path: "/pages/business-improvement-program",
        },
        {
          name: "Bodyshop Health Checks",
          path: "/pages/bodyshop-health-checks",
        },
        {
          name: "Auto-retail After-sales Process Audits",
          path: "/pages/auto-retail-after-sales-process-audits",
        },
        {
          name: "Dealership Facility Design , Planning & Execution",
          path: "/pages/dealership-facility-design-planning&execution",
        },
        {
          name: "Auto Retail Management Software",
          path: "/pages/auto-retail-management-software",
        },
        {
          name: "Skill Enhancement Programs",
          path: "/pages/skill-enhancement-programs",
        },
      ],
    },
    { text: "Clients", className: styles.navItem, path: "/clients" },
    {
      text: "Reviews & Blogs",
      className: styles.navItem,
      path: "/reviews-and-blogs",
    },
    {
      text: "Bodyshop Potential",
      className: styles.navItem,
      path: "/bodyshop-potential",
    },
    { text: "Case Studies", className: styles.navItem, path: "/case-studies" },
    { text: "Contact Us", className: styles.navItem, path: "/contact-us" },
    {
      text: "Information Policy",
      isDropDown: false,
      path: undefined,
      // subMenu: [
      //   { name: "About Us", path: "/about-us" },
      //   { name: "Contact Us", path: "/contact-us" },
      //   { name: "Terms of Use", path: "/terms-of-use" },
      //   { name: "Privacy Policy", path: "/privacy-policy" },
      // ],
      submenu: informations,
      className: styles.navItemNarrow,
    },
  ]);

  const fetchData = async () => {
    const response = await fetch(
      `${API_BASE_URL}pages/get/all?category=6708c40b5e9b4984e1e22139&page=1&limit=6&homeHeaderOrder=true`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    const data = await response.json();
    if (data?.success) {
      console.log("navabr rrr", data);
      const subMenu = data?.data?.map((item) => ({
        name: item?.name,
        path: `/pages/${item?.slug}`,
      }));
      console.log("submenu rr", subMenu);
      const newArray = navItems.map((data) => {
        if (data?.text == "Products & Services") {
          return { ...data, subMenu: subMenu };
        } else {
          return data;
        }
      });
      setNavItems(newArray);
    }
    // setList(data?.data?.sort((a, b) => a.priority - b.priority));
    console.log("data pages", data);

    if (!response.ok) {
      // message.error(data.message);
      throw new Error(data.message);
    }

    // return data.data;
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    setNavItems((prevNavItems) =>
      prevNavItems.map((item) =>
        item.text === "Information Policy"
          ? { ...item, subMenu: informations }
          : item
      )
    );
  }, [informations]);

  const navigate = useNavigate();

  const submenuRef = useRef(null);

  const itemClick = (name) => {
    console.log("name value is", name);
    setNavItems(
      navItems.map((item) =>
        item.text == name
          ? { ...item, isDropDown: !item.isDropDown }
          : { ...item, isDropDown: false }
      )
    );
  };

  console.log("nav items are", navItems);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (submenuRef.current && !submenuRef.current.contains(event.target)) {
        setNavItems(navItems.map((item) => ({ ...item, isDropDown: false })));
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [navItems]);

  //fetch information policy

  useEffect(() => {
    const fetchRecentPosts = async () => {
      try {
        const response = await fetch(
          `${API_BASE_URL}information-policy/getAll/public`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
        const data = await response.json();
        const final = data?.data?.map((item) => ({
          name: item?.data?.title,
          slug: item?.slug,
        }));
        setInformations(final);
      } catch (error) {
        console.log("error is", error);
      }
    };

    fetchRecentPosts();
  }, []);

  console.log("informations are", informations);

  return (
    <div className={styles.navMain}>
      <div className={styles.navOuter}>
        <img
          src="/img/bodyshop/bodyshop-icon.svg"
          className={styles.navTitle}
          onClick={() => navigate("/")}
        ></img>
        <div className={styles.navItems}>
          {navItems.map((item) => (
            <div className={styles.navMenu}>
              <h2
                onClick={() => {
                  itemClick(item.text);
                  if (item.path) {
                    navigate(item.path);
                  }
                }}
                className={styles.navItem}
              >
                {item.text}
              </h2>
              {item?.isDropDown && item?.subMenu?.length > 0 && (
                <div ref={submenuRef} className={styles.subMenu}>
                  {item?.subMenu?.map((data) => (
                    <div
                      className={styles.subItem}
                      onClick={() => {
                        if (data?.path) {
                          navigate(data?.path);
                        }
                        if (data?.slug) {
                          navigate(`/information-policy/${data?.slug}`);
                        }
                        if (data?.path || data?.slug) {
                          setNavItems(
                            navItems.map((item) => ({
                              ...item,
                              isDropDown: false,
                            }))
                          );
                        }
                      }}
                      onMouseEnter={() => {
                        setSelectedItem(data.name);
                        setIsHovered(true);
                      }}
                      onMouseLeave={() => {
                        setSelectedItem("");
                        setIsHovered(false);
                      }}
                    >
                      <p>{data.name}</p>
                      <img
                        src={
                          isHovered && selectedItem == data.name
                            ? "/img/bodyshop/light-blue-arrows.svg"
                            : "/img/bodyshop/light-blue-arrow.svg"
                        }
                      />
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
        {/* <button className={styles.bookSer}>Book Service</button> */}
        <img
          onClick={() => setIsVisible(!isVisible)}
          className={styles.burgerMenu}
          src="/img/bodyshop/burger-menu.svg"
        />
        <div
          onClick={() => setIsVisible(false)}
          className={!isVisible ? styles.backShadow : styles.backShadowShow}
        ></div>
        <div className={isVisible ? styles.sideMenu : styles.sideMenuHide}>
          <NavigationMenu setIsVisible={setIsVisible} navItems={navItems} />
        </div>
      </div>
    </div>
  );
}

export default Navbar;
